function clamp(value, min = 0, max = 255) {
  return Math.min(max, Math.max(min, value));
}

function normalizeHex(input) {
  const value = String(input || '').trim();
  if (!/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value)) return null;
  if (value.length === 7) return value.toLowerCase();
  const short = value.slice(1).toLowerCase();
  return `#${short[0]}${short[0]}${short[1]}${short[1]}${short[2]}${short[2]}`;
}

function hexToRgb(hex) {
  const clean = normalizeHex(hex);
  if (!clean) return null;
  const raw = clean.slice(1);
  return {
    r: Number.parseInt(raw.slice(0, 2), 16),
    g: Number.parseInt(raw.slice(2, 4), 16),
    b: Number.parseInt(raw.slice(4, 6), 16),
  };
}

function rgbToHex({ r, g, b }) {
  const toPart = (n) => clamp(Math.round(n)).toString(16).padStart(2, '0');
  return `#${toPart(r)}${toPart(g)}${toPart(b)}`;
}

function mix(hexA, hexB, weight = 0.5) {
  const a = hexToRgb(hexA);
  const b = hexToRgb(hexB);
  if (!a || !b) return normalizeHex(hexA) || normalizeHex(hexB) || null;
  const w = Math.max(0, Math.min(1, Number(weight)));
  return rgbToHex({
    r: a.r + (b.r - a.r) * w,
    g: a.g + (b.g - a.g) * w,
    b: a.b + (b.b - a.b) * w,
  });
}

export function resolveThemeColors(input = {}) {
  const primary = normalizeHex(input.primaryColor);
  const background = normalizeHex(input.backgroundColor);
  const text = normalizeHex(input.textColor);
  const secondary =
    normalizeHex(input.secondaryColor) || (primary ? mix(primary, '#000000', 0.18) : null);

  const primaryHover = secondary || (primary ? mix(primary, '#000000', 0.14) : null);
  const primaryActive = primary ? mix(primary, '#000000', 0.22) : primaryHover;
  const primarySoft = primary ? mix(primary, '#ffffff', 0.86) : null;
  const border = text && background ? mix(text, background, 0.82) : null;
  const cardBackground = background ? mix(background, '#ffffff', 0.12) : null;
  const inputBorder = border || (background ? mix(background, '#000000', 0.14) : null);
  const icon = primary || text || null;
  const mutedText = text && background ? mix(text, background, 0.45) : null;

  return {
    primary,
    secondary,
    background,
    text,
    primaryHover,
    primaryActive,
    primarySoft,
    border,
    cardBackground,
    inputBorder,
    icon,
    mutedText,
  };
}
